import React from 'react';
import { injectIntl, IntlShape } from 'react-intl';

export interface InfoBlocProps {
  intl: IntlShape;
  children?: React.ReactNode;
  title: string;
  value?: string;
  claimStatus?: string;
}

export const InfoBloc: React.FC<InfoBlocProps> = ({
  title,
  value,
  claimStatus,
  ...props
}): JSX.Element => {
  return (
    <div className="item">
      <div>{props.children}</div>
      <div className="title">{title}</div>
      {value !== undefined ? (
        <div className="value">{value}</div>
      ) : (
        <div className="status">
          <span className="status-text">{claimStatus}</span>
        </div>
      )}
    </div>
  );
};

export default injectIntl(InfoBloc);
